import type { HNVelgBehandlingsstedFrontend } from '../types/Resources';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { createResourcesApi } from '@helsenorge/framework-utils/resources';

import defaultResources from './HN.VelgBehandlingssted.Frontend.nb-NO.json';
import { HN_VELG_BEHANDLINGSSTED_FRONTEND } from '../utils/resources-project';

const getBundledResources = (projectName: string, language: LanguageLocales): HNVelgBehandlingsstedFrontend | undefined => {
  if (projectName === HN_VELG_BEHANDLINGSSTED_FRONTEND && language === LanguageLocales.NORWEGIAN) {
    return defaultResources;
  }
};

const fetchResources = async (projectName: string, language: LanguageLocales): Promise<HNVelgBehandlingsstedFrontend> => {
  try {
    const resources = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};

export const { resourcesApi, useResources } = createResourcesApi<HNVelgBehandlingsstedFrontend>({
  getBundledResources: getBundledResources,
  fetchResources: fetchResources,
});
